import React from 'react'

import Question from './Question'

import css from './styles.module.scss'

const Category = ({ name, questions, forwardRef }) => {
  return (
    <div className={css.Category} ref={forwardRef}>
      {questions.map((question, i) => {
        return <Question key={`question-${name}-${i}`} {...question} />
      })}
    </div>
  )
}

export default Category
